;(function ($) {
	"use strict";
	window.Whisperers = function (options) {
		this._init(options);
	};

	$.extend(Whisperers.prototype, {
		$options: {},

		//=====================================================================
		// Inputs with whisperer
		//=====================================================================

		initSelects: function ()
		{
			var app = this;
			$('.js-whisperer-select').each(function (i, el) {
				app.initSelect($(el), null);
			});
			$('.js-whisperer-input').each(function (i, el) {
				app.initInput($(el));
			});
		},

		initSelect($select, $parentElement) {
			var app = this,
				url = $select.data('source'),
				minInputLength = $select.data('minInputLength'),
				onCitySelectCallback = $select.data('citySelectCallback'),
				onSheriffSelectCallback = $select.data('sheriffSelectCallback'),
				useValue = $select.hasClass("js-whisperer-use-value"),
				useText = $select.hasClass("js-whisperer-use-text"),
				containerClass = $select.get(0).hasAttribute("data-container-class") ? $select.data('containerClass') : 'form-control',
				term = null,
				opening = false,
				$streetInput = null;
			if ($select.data('whisperZip') === "city") {
				$streetInput = $select.closest('div.panel').find('select[data-whisper-zip=street]');
			}
			
			var options = {
				ajax: null,
				containerCssClass: containerClass,
				width: '100%',
				dropdownAutoWidth: true,
				minimumInputLength: (minInputLength !== undefined) ? minInputLength : 2,

				tags: ($select.hasClass('js-select-allow-tags') ? true : false),
				createTag: ($select.hasClass('js-select-allow-tags')
					? function (params) {
						var term = $.trim(params.term);
						if (term === '') {
							return null;
						}
						return {
							id: term,
							text: term,
							newTag: true // add additional parameters
						}
					}
					: false),
				language: "cs",
			};
			if (url)
			{
				options.ajax = {
					url: url,
					dataType: 'json',
					method: 'post',
					delay: 250,
					data: function (params) {
						term = params.term;
						var res = { term : term };
						if ($streetInput) {
							res.street = $streetInput.val();
						}
						if ($select.data('guiltDate')) {
							res.date = $select.data('guiltDate');
						}
						return res
					},
					processResults: function (data) {
						var result = null;
						if (useText) {
							result = [];
							for (var i in data.items) {
								result.push({ 'id': data.items[i].text, 'text': data.items[i].text });
							}
						} else {
							result = data.items;
						}
						return {
							results: result
						};
					},
					transport: function (params, success, failure) {
						var $request = $.ajax(params);
	
						$request.then(success);
	
						$request.fail(function () {
							app.ajaxFailure(success, term);
						});
	
						return $request;
					},
				};
			}
			if ($parentElement) {
				options.dropdownParent = $parentElement;
				$parentElement.removeAttr('tabindex');
			}
			
			$select.select2(
				options
			).on('select2:open', function (/*event*/) {
				var $this = $(this);
				if (!$this.data('preventSearch')) {
					var text = $this.find('option:selected').text(),
						$fields = $('input.select2-search__field'),
						fieldsCnt = $fields.length,
						$searchField = (fieldsCnt > 1) ? $(this).parent().find('input.select2-search__field') : $fields;
					opening = true;
					$searchField.val(text).trigger('keyup').select();
					$searchField.data('selectId', $select.attr('id'));
				}
			}).on('select2:results:focus', function (event) {
				if (!$(':focus').hasClass('select2-search__field'))
				{
					var $focusedLi = event.params.element,
						text = $focusedLi.text(),
						$fields = $('input.select2-search__field'),
						fieldsCnt = $fields.length,
						$searchField = (fieldsCnt > 1) ? $(this).parent().find('input.select2-search__field') : $fields;
					$searchField.val(text);
					if (opening) {
						$searchField.select();
						opening = false;
					}
				}
			}).on('select2:select', function (e) {
				if (onCitySelectCallback) {
					var value = $(this).val();
					app.citySelectCallback(value, onCitySelectCallback, $(this));
				}
				if (onSheriffSelectCallback) {
					var value = $(this).val();
					app.sheriffSelectCallback(value, onSheriffSelectCallback, $(this));
				}
				if(e.params.data.newTag){
					// append the new option element prenamently:
					$(this).find('[value="'+e.params.data.id+'"]').replaceWith('<option selected value="'+e.params.data.id+'">'+e.params.data.text+'</option>');
				}
			}).on("select2:close", function (/*event*/) {
				var $select = $(this);
				if (useValue) {
					var $option = $select.find('option:selected');
					$option.text($option.val());
				}
				/*else if (useText) {
					var $option = $select.find('option:selected');
					$option.val($option.text());
				}*/
				$select.select2("destroy");
				$select.off('select2:results:focus');
				$select.off('select2:open');
				$select.off('select2:close');
				$select.off('select2:select');
				app.initSelect($select, null);
			});
		},
		
		searchInputKeyUp: function ($input) {
			let $select = $('select#'+$input.data('selectId'));
			$select.val($input.val());
		},

		/**
		 * 
		 * @param $input
		 */
		initInput: function ($input) {
			var app = this,
				url = $input.data('source'),
				$streetInput = null;
			if ($input.data('whisperZip') === "city") {
				$streetInput = $input.closest('div.panel').find('select[data-whisper-zip=street]');
			}

			$input.typeahead({
				source: function (query, result) {
					$.ajax({
						url: url,
						data:/* {
							term : query,
							street : ($streetInput) ? $streetInput.val() : null,
						},*/  'query=' + query,
						dataType: "json",
						type: "POST",
						success: function (data) {
							result($.map(data, function (item) {
								return item;
							}));
						}
					});
				}
			});
		},

		ajaxFailure: function (successCallback, term)
		{
			var data = {
					items: [
						{
							id: 'customItem',
							text: term,
							newTag: true // add additional parameters
						},
						{
							'text': 'failed to load results from server',
							'children': []
						}
					]
			};
			successCallback(data);
		},
		
		//=====================================================================
		// Wrong doing specific callback
		//=====================================================================

		citySelectCallback: function (value, callbackUrl, $select) {
			var app = this;
			$.ajax({
				url: callbackUrl,
				dataType: 'json',
				method: 'post',
				data: {
					id: $select.val()
				},
				success: function (zip) {
					if (zip && (undefined !== zip.id))
					{
						var $panel = $select.closest('.panel'),
							$zipSelect = $panel.find("select[data-whisper-zip=zip]"),
							$countySelect = $panel.find("select[data-whisper-zip=county]"),
							$desperadoController = window.$desperadoController;

						$desperadoController.lockAuthoritySelect(true);

						$select.find('option').remove();
						$select.append($('<option value="'+zip.city+'" selected>'+zip.city+'</option>')).trigger('change');

						$zipSelect.find('option').remove();
						$zipSelect.append($('<option value="'+zip.zip+'" selected>'+zip.zip+'</option>')).trigger('change');

						$countySelect.find('option').remove();
						$countySelect.append($('<option value="'+zip.county+'" selected>'+zip.county+'</option>')).trigger('change');

						$desperadoController.lockAuthoritySelect(false);
						$desperadoController.findAuthority($zipSelect, zip);
					}
				},
				error: function () {},
			});
		},

		sheriffSelectCallback: function (value, callbackUrl, $select) {
			var app = this;
			$.ajax({
				url: callbackUrl,
				dataType: 'json',
				method: 'post',
				data: {
					s: $select.val()
				},
				success: function (shift) {
					if (shift)
					{
						var $shiftSelect = $("select#shift");

						$shiftSelect.find('option').remove();
						$shiftSelect.append($('<option value="'+shift.id+'" selected>'+shift.text+'</option>')).trigger('change');
					}
				},
				error: function () {},
			});
		},

		//=====================================================================
		
		/**
		 * HANDLE BUTTONS
		 */
		handleButtons: function() {
			var app = this,
				$document = $(document);

			$document.on('keyup', 'input.select2-search__field', function (e) {
				app.searchInputKeyUp($(this));
			});
		},

		_init: function (options) {
			this.$options = $.extend({}, this.$options, options || {});

			this.initSelects();
			this.handleButtons();
		},
	});

})(jQuery);

